import React, { useEffect, useState } from "react";
import JoinedPostcardCampaignCard from "./JoinedPostcardCampaignCard";
import TablePagination from "@/components/tables/TablePagination";
import NotAvailable from "@/components/NotAvailable";
import DataRangeDisplay from "@/components/DataRangeDisplay";
import NoDataFoundBase from "@/components/NoDataFound";

const NoDataFound = NoDataFoundBase as React.ComponentType<any>;

type JoinedPostcardCampaign = {
  id?: string | number;
  [key: string]: any;
};

type PostcardCampaignJoinedProps = {
  joinedCampaigns?: JoinedPostcardCampaign[];
  pageCount: number;
  pageIndex: number;
  onPageChange?: (_event: React.ChangeEvent<unknown>, _page: number) => void;
  recordsTotal: number;
  isLoading?: boolean;
};

function PostcardCampaignJoined({
  joinedCampaigns = [],
  pageCount,
  pageIndex,
  onPageChange,
  recordsTotal,
  isLoading,
}: PostcardCampaignJoinedProps) {
  const [campaignData, setCampaignData] = useState<JoinedPostcardCampaign[]>(
    []
  );
  useEffect(() => {
    setCampaignData(joinedCampaigns);
  }, [joinedCampaigns]);

  const renderPagination = () => {
    return (
      <div className="row">
        <div className="col-lg-6 mb-2 d-flex align-items-center">
          <DataRangeDisplay totalRecords={recordsTotal} pageIndex={pageIndex} />
        </div>
        <div className="col-lg-6 float-right">
          <TablePagination
            count={pageCount}
            page={pageIndex + 1}
            onChange={onPageChange}
            className="float-right"
          />
        </div>
      </div>
    );
  };

  if (isLoading) {
    return <NoDataFound className="my-5" message="Loading..." />;
  }

  return (
    <>
      <div className="joined-campaigns mb-1 pt-3">
        {campaignData.length ? (
          <>
            <div className="row align-items-stretch">
              <div className="col-12 d-none d-lg-block px-2">
                <div className="card border-0 heading-card">
                  <div className="card-body py-4 px-3">
                    <div className="row">
                      <div className="col-lg-3 title">Campaign Name</div>
                      <div className="col-lg-2 title pl-lg-1">Status</div>
                      <div className="col-lg-2 title">Cost</div>
                      <div className="col-lg-2 title">Enrolled Locations</div>
                      <div className="col-lg-2 title">Mailing Date</div>
                      <div className="col-lg-1 title">Helpful Content</div>
                    </div>
                  </div>
                </div>
              </div>
              {campaignData.map((c) => (
                <div
                  className="col-lg-12 col-md-6 mb-1 mb-lg-auto p-2 py-lg-0"
                  key={c.id}
                >
                  <JoinedPostcardCampaignCard campaign={c} />
                </div>
              ))}
            </div>
            {renderPagination()}
          </>
        ) : (
          <NotAvailable message="No direct mail reports are currently available." />
        )}
      </div>
    </>
  );
}

export default PostcardCampaignJoined;
